// 적립금(points) 공통 타입.
// 사용자 앱(적립금 잔액/내역), 관리자(추후 회원 적립 조정), API 가 공유한다.

// 적립금 거래 유형.
export const POINT_TX_TYPE = {
  EARN: "earn", // 적립 (수령완료 시 확정)
  SPEND: "spend", // 사용 (차감)
  ADJUST: "adjust", // 관리자 수동 조정
} as const;
export type PointTxType = (typeof POINT_TX_TYPE)[keyof typeof POINT_TX_TYPE];

// 적립금 내역 1행 DTO.
//  - amount 는 부호 있는 정수 (적립 +, 사용/취소 -).
//  - balanceAfter 는 적용 직후 잔액 스냅샷.
//  - orderNo 는 적립 출처 주문번호 (있으면 화면에서 "주문 260609-xxxx 적립" 처럼 표시).
export interface PointTransactionDto {
  id: string;
  type: PointTxType;
  amount: number;
  balanceAfter: number;
  reason: string | null;
  orderNo: string | null;
  createdAt: string;
}

// 적립 예상액 계산 (표시용 - 서버가 확정 시 동일 식으로 재계산).
// 주문 합계(total) 대비 percent% 를 내림(floor)한다.
export function computeEarnedPoints(totalKrw: number, percent: number): number {
  if (percent <= 0 || totalKrw <= 0) {
    return 0;
  }
  return Math.floor((totalKrw * percent) / 100);
}

// 적립금 표시 포맷 (예: 1,200P).
export function formatPoints(points: number): string {
  return `${points.toLocaleString()}P`;
}
